import { Radio } from 'antd';
import { FormField } from './FormField';
import type { RadioProps } from 'antd';
import type { FormFieldProps } from './FormField';
import type { ControllerFieldState } from 'react-hook-form';

export type RadioFieldProps = FormFieldProps &
    RadioProps & {
        options: { label: string; value: string }[];
        fieldState?: ControllerFieldState;
    };

export const RadioField = ({
    fieldState,
    disabled = false,
    showValidationIcon,
    error,
    correct,
    ...props
}: RadioFieldProps) => {
    const errorMessage = error || fieldState?.error?.message;
    const isValid = correct || (fieldState?.isDirty && !fieldState?.error?.message);

    const getInputClassName = () => {
        if (errorMessage) {
            return 'incorrect';
        }

        if (isValid) {
            return 'correct';
        }

        return '';
    };

    return (
        <FormField
            {...props}
            fieldState={fieldState}
            labelFor={props?.id || props.name}
            error={error}
            correct={correct}
            showValidationIcon={showValidationIcon}>
            <Radio.Group
                {...props}
                id={props?.id || props.name}
                className={getInputClassName()}
                disabled={disabled}>
                {props.options.map((option) => (
                    <Radio key={option.value} value={option.value}>
                        {option.label}
                    </Radio>
                ))}
            </Radio.Group>
        </FormField>
    );
};
